import * as React from 'react';

import { WebProtocol } from 'src/constants/web';
import * as copy from 'src/templates/copy';

type WebProtocolWarningMessageProps = {
  appProtocol: WebProtocol;
  endpointProtocol: WebProtocol;
  isEndpointLocalhost: boolean;
};

export const WebProtocolWarningMessage: React.VFC<
  WebProtocolWarningMessageProps
> = ({ appProtocol, endpointProtocol, isEndpointLocalhost }) => {
  let messageElement: React.ReactNode;
  if (appProtocol === WebProtocol.HTTP && isEndpointLocalhost) {
    messageElement = copy.components.webProtocolWarning.httpToLocal();
  } else if (
    appProtocol === WebProtocol.HTTPS &&
    endpointProtocol === WebProtocol.HTTP
  ) {
    messageElement = copy.components.webProtocolWarning.httpsToHttp();
  } else if (
    appProtocol === WebProtocol.HTTP &&
    endpointProtocol === WebProtocol.HTTPS
  ) {
    messageElement = copy.components.webProtocolWarning.httpToHttps();
  }
  return <>{messageElement}</>;
};
